import { withAsync } from '@/components'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/404',
    component: withAsync(() => import(/* webpackChunkName: "Error/NotAuthPage" */ '@/containers/NotAuthPage')),
    exact: true,
  },
]

export default routes
